import useSWR, { mutate } from 'swr';
import { useMemo } from 'react';

const DRAWER_STORAGE_KEY = 'cl-drawer-pinned';

const endpoints = {
  key: 'api/menu',
  master: 'master',
  dashboard: '/dashboard'
};

function readPinnedDrawer() {
  try {
    return typeof localStorage !== 'undefined' && localStorage.getItem(DRAWER_STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

function writePinnedDrawer(isOpen) {
  try {
    localStorage.setItem(DRAWER_STORAGE_KEY, isOpen ? '1' : '0');
  } catch {
    /* ignore quota / private mode */
  }
}

const initialState = {
  isDashboardDrawerOpened: readPinnedDrawer(),
  isDrawerPeeking: false
};

export function isDrawerVisualOpen(menuMaster) {
  return Boolean(menuMaster?.isDashboardDrawerOpened || menuMaster?.isDrawerPeeking);
}

export function useGetMenuMaster() {
  const { data, isLoading } = useSWR(endpoints.key + endpoints.master, () => initialState, {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    fallbackData: initialState
  });

  const memoizedValue = useMemo(
    () => ({
      menuMaster: data,
      menuMasterLoading: isLoading
    }),
    [data, isLoading]
  );

  return memoizedValue;
}

export function handlerDrawerOpen(isDashboardDrawerOpened) {
  writePinnedDrawer(isDashboardDrawerOpened);
  mutate(
    endpoints.key + endpoints.master,
    (currentMenuMaster) => ({
      ...currentMenuMaster,
      isDashboardDrawerOpened,
      isDrawerPeeking: false
    }),
    false
  );
}

export function handlerDrawerPeek(isDrawerPeeking) {
  mutate(
    endpoints.key + endpoints.master,
    (currentMenuMaster) => {
      if (currentMenuMaster?.isDashboardDrawerOpened) {
        return { ...currentMenuMaster, isDrawerPeeking: false };
      }
      return { ...currentMenuMaster, isDrawerPeeking };
    },
    false
  );
}
